import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminSpamDebug from "@/pages/admin/AdminSpamDebug";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/spam-debug")({
  head: () => adminHead("Spam Filter Debug | Admin", "Test and tune spam filter patterns and whitelist overrides.", "/admin/spam-debug"),
  component: () => (
    <ProtectedRoute>
      <AdminSpamDebug />
    </ProtectedRoute>
  ),
});
